<template>
    <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.7331 10.7356C10.3463 11.1224 10.3463 11.7495 10.7331 12.1362L14.4682 15.8713L10.7333 19.6061C10.3465 19.9929 10.3465 20.62 10.7333 21.0067C11.1201 21.3935 11.7471 21.3935 12.1339 21.0067L15.8688 17.2719L19.6036 21.0067C19.9903 21.3935 20.6174 21.3935 21.0042 21.0067C21.3909 20.6199 21.3909 19.9929 21.0042 19.6061L17.2693 15.8713L21.0043 12.1363C21.3911 11.7495 21.3911 11.1224 21.0043 10.7357C20.6176 10.3489 19.9905 10.3489 19.6037 10.7357L15.8687 14.4707L12.1337 10.7356C11.7469 10.3489 11.1199 10.3489 10.7331 10.7356Z"
            fill="currentColor"
        />
    </svg>
</template>
